'use client';

import { useState } from 'react';

export default function ContactPage() {
    const [sent, setSent] = useState(false);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const submit = async (e: any) => {
        e.preventDefault();
        await fetch('/api/support/contact', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ name, email, message }) });
        setSent(true);
    };

    return (
        <div className="max-w-3xl mx-auto px-4 py-12 text-neutral-100">
            <h1 className="text-3xl font-bold mb-4">Contact Support</h1>
            <p className="text-neutral-400 mb-6">Questions? Send a message and we will get back to you.</p>

            {sent ? (
                <div className="p-6 bg-green-900/20 rounded">Thanks — your message has been received.</div>
            ) : (
                <form onSubmit={submit} className="space-y-4">
                    <input className="input w-full" placeholder="Name" value={name} onChange={(e)=>setName(e.target.value)} />
                    <input className="input w-full" placeholder="Email" value={email} onChange={(e)=>setEmail(e.target.value)} />
                    <textarea className="input w-full h-32" placeholder="Message" value={message} onChange={(e)=>setMessage(e.target.value)} />
                    <button className="btn-primary">Send Message</button>
                </form>
            )}
        </div>
    );
}
